<ng-container *transloco="let t">
  <div class="header-wrapper">
    <mzic-header></mzic-header>
  </div>

  <!-- Hero Section -->
  <section class="hero-section">
    <div class="section-container">
      <div class="hero-content">
        <p class="hero-subtitle-small">
          {{ t('marketLang.hero.subtitle_small') }}
        </p>
        <h1 class="hero-title">
          {{ t('marketLang.hero.title') }}
        </h1>
        <p class="hero-description">
          {{ t('marketLang.hero.description') }}
          <br />
        </p>
      </div>

      <!-- Accordion Section -->
      <div class="accordion-wrapper">
        <mzic-accordion
          #industrySizeAccordion
          [title]="'marketLang.accordions.industrySize.title'"
          [isOpen]="activeAccordion === 'industrySize'"
          (toggle)="toggleAccordion('industrySize')">
          <!-- Intro com links -->
          <p>
            {{ t('marketLang.accordions.industrySize.content.intro_part1') }}
            <a
              [href]="
                t('marketLang.accordions.industrySize.content.intro_link1_url')
              "
              target="_blank"
              class="accordion-link">
              {{
                t('marketLang.accordions.industrySize.content.intro_link1_text')
              }}
            </a>
            {{ t('marketLang.accordions.industrySize.content.intro_part2') }}
            <a
              [href]="
                t('marketLang.accordions.industrySize.content.intro_link2_url')
              "
              target="_blank"
              class="accordion-link">
              {{
                t('marketLang.accordions.industrySize.content.intro_link2_text')
              }}
            </a>
            {{ t('marketLang.accordions.industrySize.content.intro_part3') }}
          </p>

          <!-- Título do gráfico -->
          <h3 class="graph-title">
            {{ t('marketLang.accordions.industrySize.content.graphTitle') }}
          </h3>

          <!-- Imagem em full width -->
          <picture>
            <source
              media="(max-width: 768px)"
              [srcset]="industrySizeChartMobile()" />
            <img
              [src]="industrySizeChartDesktop()"
              alt="Industry Size Chart"
              class="full-width-image limited" />
          </picture>

          <!-- Fonte do gráfico -->
          <p class="graph-source">
            {{ t('marketLang.accordions.industrySize.content.graphSource') }}
          </p>

          <!-- Textos após o gráfico -->
          <p>
            {{
              t(
                'marketLang.accordions.industrySize.content.afterGraphParagraph1'
              )
            }}
          </p>

          <p>
            {{
              t(
                'marketLang.accordions.industrySize.content.afterGraphParagraph2'
              )
            }}
          </p>

          <p>
            {{
              t(
                'marketLang.accordions.industrySize.content.afterGraphParagraph3'
              )
            }}
          </p>

          <p>
            {{
              t(
                'marketLang.accordions.industrySize.content.afterGraphParagraph4'
              )
            }}
          </p>

          <p class="accordion-explanation">
            {{
              t(
                'marketLang.accordions.industrySize.content.tradeNoteExplanation'
              )
            }}
          </p>

          <!-- Segundo gráfico - Industry Revenue -->
          <h3 class="industry-revenue-title">
            {{
              t('marketLang.accordions.industrySize.content.industryRevenueTitle')
            }}
          </h3>

          <picture>
            <source
              media="(max-width: 768px)"
              [srcset]="recordedIndustryChartMobile()" />
            <img
              [src]="recordedIndustryChartDesktop()"
              alt="Industry Revenue Graph"
              class="full-width-image max-width-996" />
          </picture>

          <p class="industry-revenue-source">
            {{
              t(
                'marketLang.accordions.industrySize.content.industryRevenueSource'
              )
            }}
          </p>

          <h3 class="accordion-subtitle">
            {{ t('marketLang.accordions.industrySize.content.brazilSubtitle') }}
          </h3>

          <p>
            {{
              t('marketLang.accordions.industrySize.content.paragraph1_part1')
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.industrySize.content.paragraph1_link1_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.industrySize.content.paragraph1_link1_text'
                )
              }}
            </a>
            {{
              t('marketLang.accordions.industrySize.content.paragraph1_part2')
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.industrySize.content.paragraph1_link2_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.industrySize.content.paragraph1_link2_text'
                )
              }}
            </a>
            {{
              t('marketLang.accordions.industrySize.content.paragraph1_part3')
            }}
          </p>

          <p>
            {{
              t('marketLang.accordions.industrySize.content.paragraph2_part1')
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.industrySize.content.paragraph2_link_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.industrySize.content.paragraph2_link_text'
                )
              }}
            </a>
            {{
              t('marketLang.accordions.industrySize.content.paragraph2_part2')
            }}
          </p>

          <p>
            {{ t('marketLang.accordions.industrySize.content.paragraph3') }}
          </p>

          <!-- Duas imagens lado a lado -->
          <div class="side-by-side-images">
            <div class="chart-container">
              <h4 class="chart-title">
                {{
                  t('marketLang.accordions.industrySize.content.topCountriesTitle')
                }}
              </h4>
              <p class="chart-subtitle">
                {{
                  t(
                    'marketLang.accordions.industrySize.content.topCountriesSubtitle'
                  )
                }}
              </p>
              <img
                [src]="topCountriesList()"
                alt="Top Countries List"
                class="half-width-image ranking" />
              <p class="chart-source">
                {{
                  t(
                    'marketLang.accordions.industrySize.content.topCountriesSource'
                  )
                }}
              </p>
            </div>

            <div class="chart-container">
              <h4 class="chart-title">
                {{
                  t(
                    'marketLang.accordions.industrySize.content.streamingTrendsTitle'
                  )
                }}
              </h4>
              <p class="chart-subtitle">
                {{
                  t(
                    'marketLang.accordions.industrySize.content.streamingTrendsSubtitle'
                  )
                }}
              </p>
              <picture>
                <source
                  media="(max-width: 768px)"
                  [srcset]="recordedIndustryChartMobileSideBySide()" />
                <img
                  [src]="recordedIndustryChartDesktopSideBySide()"
                  alt="Streaming Trends Chart"
                  class="half-width-image" />
              </picture>
              <p class="chart-source">
                {{
                  t(
                    'marketLang.accordions.industrySize.content.streamingTrendsSource'
                  )
                }}
              </p>
            </div>
          </div>

          <!-- Parágrafo sobre ECAD -->
          <p>
            {{
              t(
                'marketLang.accordions.industrySize.content.ecadParagraph_part1'
              )
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.industrySize.content.ecadParagraph_link_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.industrySize.content.ecadParagraph_link_text'
                )
              }}
            </a>
            {{
              t(
                'marketLang.accordions.industrySize.content.ecadParagraph_part2'
              )
            }}
          </p>
        </mzic-accordion>

        <mzic-accordion
          #howMusicGeneratesRevenueAccordion
          [title]="'marketLang.accordions.howMusicGeneratesRevenue.title'"
          [isOpen]="activeAccordion === 'howMusicGeneratesRevenue'"
          (toggle)="toggleAccordion('howMusicGeneratesRevenue')">
          <p>
            {{
              t(
                'marketLang.accordions.howMusicGeneratesRevenue.content.paragraph1'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.howMusicGeneratesRevenue.content.paragraph2'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.howMusicGeneratesRevenue.content.paragraph3'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.howMusicGeneratesRevenue.content.paragraph4'
              )
            }}
          </p>

          <div class="revenue-carousel-wrapper">
            <div class="carousel-container" #carouselContainer>
              <div class="carousel-track">
                <div
                  class="revenue-card"
                  *ngFor="let card of revenueCards; let i = index">
                  <!-- Badges para o primeiro card -->
                  <div
                    class="card-badges platforms"
                    *ngIf="card.type === 'badges' && card.badges">
                    <div class="badge" *ngFor="let badge of card.badges">
                      <img
                        [src]="badge.icon"
                        [alt]="t(badge.textKey)"
                        width="24"
                        height="24" />
                      <span>{{ t(badge.textKey) }}</span>
                    </div>
                  </div>

                  <!-- Ícones grandes para os demais cards -->
                  <div
                    class="card-icons"
                    *ngIf="card.type === 'icons' && card.icons">
                    <div class="large-icon" *ngFor="let icon of card.icons">
                      <img
                        *ngIf="icon"
                        [src]="icon"
                        alt="Icon"
                        width="42"
                        height="42" />
                    </div>
                  </div>

                  <h4 class="card-title">
                    {{
                      t(
                        'marketLang.accordions.howMusicGeneratesRevenue.content.cards.' +
                          card.key +
                          '.title'
                      )
                    }}
                  </h4>
                  <p
                    class="card-description"
                    [innerHTML]="
                      t(
                        'marketLang.accordions.howMusicGeneratesRevenue.content.cards.' +
                          card.key +
                          '.description'
                      )
                    "></p>
                </div>
              </div>
            </div>
            <button
              *ngIf="showRightButton"
              class="carousel-nav-button carousel-nav-button-right"
              (click)="scrollCarousel()"
              aria-label="Navegar para direita">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 18L15 12L9 6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
            <button
              *ngIf="showLeftButton"
              class="carousel-nav-button carousel-nav-button-left"
              (click)="scrollCarouselBack()"
              aria-label="Navegar para esquerda">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M15 18L9 12L15 6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </mzic-accordion>

        <mzic-accordion
          #whyInvestInMusicAccordion
          [title]="'marketLang.accordions.whyInvestInMusic.title'"
          [isOpen]="activeAccordion === 'whyInvestInMusic'"
          (toggle)="toggleAccordion('whyInvestInMusic')">
          <!-- Intro -->
          <p>{{ t('marketLang.accordions.whyInvestInMusic.content.intro') }}</p>

          <!-- Subtítulo: Baixa correlação com a economia -->
          <h3 class="accordion-subtitle">
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.lowCorrelation.subtitle'
              )
            }}
          </h3>

          <!-- 3 parágrafos sobre baixa correlação -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.lowCorrelation.paragraph1'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.lowCorrelation.paragraph2'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.lowCorrelation.paragraph3'
              )
            }}
          </p>

          <!-- Subtítulo: Retornos atrativos -->
          <h3 class="accordion-subtitle">
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.subtitle'
              )
            }}
          </h3>

          <!-- Parágrafo 1: fundos de royalties -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph1'
              )
            }}
          </p>

          <!-- Parágrafo 2: Manda um Oi (com link) -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph2_part1'
              )
            }}
            <a
              [href]="
                'https://' +
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph2_link_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph2_link_text'
                )
              }}
            </a>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph2_part2'
              )
            }}
          </p>

          <!-- Parágrafo 3: alcance global -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph3'
              )
            }}
          </p>

          <!-- Parágrafo 4: Gusttavo Lima -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph4'
              )
            }}
          </p>

          <!-- Parágrafo 5: Primary Wave e Adaggio (com 2 links) -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_part1'
              )
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_link1_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_link1_text'
                )
              }}
            </a>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_part2'
              )
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_link2_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_link2_text'
                )
              }}
            </a>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_part3'
              )
            }}
          </p>

          <!-- Parágrafo 6: Top 10 e 4,8 trilhões (com 2 links) -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_part1'
              )
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_link1_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_link1_text'
                )
              }}
            </a>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_part2'
              )
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_link2_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_link2_text'
                )
              }}
            </a>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_part3'
              )
            }}
          </p>

          <!-- Parágrafo 7: majors (Universal, Warner, Sony - com 3 links) -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_part1'
              )
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link1_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link1_text'
                )
              }}
            </a>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_part2'
              )
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link2_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link2_text'
                )
              }}
            </a>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_part3'
              )
            }}
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link3_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link3_text'
                )
              }}
            </a>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_part4'
              )
            }}
          </p>

          <!-- Explanations (EBITDA e OIBDA) -->
          <br />
          <p class="accordion-explanation">
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.explanation1'
              )
            }}
          </p>
          <p class="accordion-explanation">
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.explanation2'
              )
            }}
          </p>

          <!-- Subtítulo: Estabilidade e recorrência -->
          <h3 class="accordion-subtitle">
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.stability.subtitle'
              )
            }}
          </h3>

          <!-- 3 parágrafos sobre estabilidade e recorrência -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.stability.paragraph1'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.stability.paragraph2'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.stability.paragraph3'
              )
            }}
          </p>

          <!-- Subtítulo: Diversificação de carteira -->
          <h3 class="accordion-subtitle">
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.diversification.subtitle'
              )
            }}
          </h3>

          <!-- 3 parágrafos sobre diversificação de carteira -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.diversification.paragraph1'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.diversification.paragraph2'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.diversification.paragraph3'
              )
            }}
          </p>
        </mzic-accordion>

        <mzic-accordion
          #moneyFlowAccordion
          [title]="'marketLang.accordions.moneyFlow.title'"
          [isOpen]="activeAccordion === 'moneyFlow'"
          (toggle)="toggleAccordion('moneyFlow')">
          <!-- Parágrafo introdutório -->
          <p>
            {{ t('marketLang.accordions.moneyFlow.content.intro') }}
          </p>

          <!-- Imagem do fluxograma -->
          <picture>
            <img
              [src]="musicRoyaltiesFlowChart()"
              alt="Music Flowchart"
              class="full-width-image max-width-996" />
          </picture>

          <!-- Subtítulo: Royalties musicais -->
          <h3 class="accordion-subtitle">
            {{ t('marketLang.accordions.moneyFlow.content.royaltiesSubtitle') }}
          </h3>

          <!-- Parágrafo sobre royalties -->
          <p>
            {{
              t('marketLang.accordions.moneyFlow.content.royaltiesParagraph')
            }}
          </p>

          <!-- Tópicos de royalties -->
          <p class="topic-paragraph">
            <span class="topic-title">
              {{ t('marketLang.accordions.moneyFlow.content.topic1_title') }}
            </span>
            {{ t('marketLang.accordions.moneyFlow.content.topic1_text') }}
          </p>

          <p class="topic-paragraph">
            <span class="topic-title">
              {{ t('marketLang.accordions.moneyFlow.content.topic2_title') }}
            </span>
            {{ t('marketLang.accordions.moneyFlow.content.topic2_text') }}
          </p>

          <p class="topic-paragraph">
            <span class="topic-title">
              {{ t('marketLang.accordions.moneyFlow.content.topic3_title') }}
            </span>
            {{ t('marketLang.accordions.moneyFlow.content.topic3_text') }}
          </p>

          <p class="topic-paragraph">
            <span class="topic-title">
              {{ t('marketLang.accordions.moneyFlow.content.topic4_title') }}
            </span>
            {{ t('marketLang.accordions.moneyFlow.content.topic4_text') }}
          </p>

          <!-- Subtítulo: Outros agentes envolvidos no fluxo -->
          <h3 class="accordion-subtitle">
            {{ t('marketLang.accordions.moneyFlow.content.agentsSubtitle') }}
          </h3>

          <!-- Tópicos de agentes -->
          <p class="topic-paragraph">
            <span class="topic-title">
              {{ t('marketLang.accordions.moneyFlow.content.agent1_title') }}
            </span>
            {{ t('marketLang.accordions.moneyFlow.content.agent1_text') }}
          </p>

          <p class="topic-paragraph">
            <span class="topic-title">
              {{ t('marketLang.accordions.moneyFlow.content.agent2_title') }}
            </span>
            {{ t('marketLang.accordions.moneyFlow.content.agent2_text') }}
          </p>

          <p class="topic-paragraph">
            <span class="topic-title">
              {{ t('marketLang.accordions.moneyFlow.content.agent3_title') }}
            </span>
            {{ t('marketLang.accordions.moneyFlow.content.agent3_text') }}
          </p>

          <p class="topic-paragraph">
            <span class="topic-title">
              {{ t('marketLang.accordions.moneyFlow.content.agent4_title') }}
            </span>
            {{ t('marketLang.accordions.moneyFlow.content.agent4_text') }}
          </p>
        </mzic-accordion>

        <mzic-accordion
          #musicEvolutionAccordion
          [title]="'marketLang.accordions.musicEvolution.title'"
          [isOpen]="activeAccordion === 'musicEvolution'"
          (toggle)="toggleAccordion('musicEvolution')">
          <p>
            {{ t('marketLang.accordions.musicEvolution.content.paragraph1') }}
          </p>
          <p>
            {{ t('marketLang.accordions.musicEvolution.content.paragraph2') }}
          </p>
          <p>
            {{ t('marketLang.accordions.musicEvolution.content.paragraph3') }}
          </p>
          <p>
            {{ t('marketLang.accordions.musicEvolution.content.paragraph4') }}
          </p>
          <p>
            {{ t('marketLang.accordions.musicEvolution.content.paragraph5') }}
          </p>
          <p>
            {{ t('marketLang.accordions.musicEvolution.content.paragraph6') }}
          </p>
          <p>
            {{ t('marketLang.accordions.musicEvolution.content.paragraph7') }}
          </p>
        </mzic-accordion>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <mzic-footer></mzic-footer>
</ng-container>
